import { atom } from 'jotai';

export const isDrawerSideBarExpandedAtom = atom<boolean>(false);
